"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.ScreenEmbedPropertyMismatchAnalyticsEvent = exports.ScreenEmbedPayNowReviewAnalyticsEvent = exports.ScreenEmbedCongratsAnalyticsEvent = exports.ScreenEmbedBlockingRentProgressAnalyticsEvent = exports.ScreenEmbedBlockingPaymentStartedAnalyticsEvent = exports.ScreenEmbedBlockingNotRentDayAnalyticsEvent = exports.ScreenEmbedBlockingInvalidProductAnalyticsEvent = exports.ScreenEmbedBlockingIneligibleAnalyticsEvent = exports.ScreenEmbedBlockingAutopayOnAnalyticsEvent = exports.ScreenEmbedBalanceOutOfRangeAnalyticsEvent = exports.EmbedReviewPaymentsClickedAnalyticsEvent = exports.EmbedEligibilityFailureCodeAnalyticsEvent = exports.EmbedCongratsAutopayOffButtonClickAnalyticsEvent = exports.EmbedCheckEligibilityErrorAnalyticsEvent = exports.EmbedBillStatusServiceIssueBlockingAnalyticsEvent = exports.EmbedBillStatusBlockingErrorAnalyticsEvent = exports.EmbedBillStatusBlockingAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when user lands on the RXP Embed Flow Blocking Screen 'Auotpay On'
 */
var ScreenEmbedBlockingAutopayOnAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_embed_blocking_autopay_on');
exports.ScreenEmbedBlockingAutopayOnAnalyticsEvent = ScreenEmbedBlockingAutopayOnAnalyticsEvent;
/**
 * Triggers when user lands on the RXP Embed Flow Blocking Screen 'Invalid Product'
 */
var ScreenEmbedBlockingInvalidProductAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_embed_blocking_invalid_product');
exports.ScreenEmbedBlockingInvalidProductAnalyticsEvent = ScreenEmbedBlockingInvalidProductAnalyticsEvent;
/**
 * Triggers when user lands on the RXP Embed Flow Blocking Screen 'Not Your Rent Day'
 */
var ScreenEmbedBlockingNotRentDayAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_embed_blocking_not_rent_day');
exports.ScreenEmbedBlockingNotRentDayAnalyticsEvent = ScreenEmbedBlockingNotRentDayAnalyticsEvent;
/**
 * Triggers when user lands on the RXP Embed Flow Blocking Screen 'Property Mismatch'
 */
var ScreenEmbedPropertyMismatchAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_embed_property_mismatch');
exports.ScreenEmbedPropertyMismatchAnalyticsEvent = ScreenEmbedPropertyMismatchAnalyticsEvent;
/**
 * Triggers when user lands on the RXP Embed Flow Blocking Screen 'Payment Started'
 */
var ScreenEmbedBlockingPaymentStartedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_embed_blocking_payment_started');
exports.ScreenEmbedBlockingPaymentStartedAnalyticsEvent = ScreenEmbedBlockingPaymentStartedAnalyticsEvent;
/**
 * Triggers when user lands on the RXP Embed Flow Blocking Screen 'Split Rent In Progress'
 */
var ScreenEmbedBlockingRentProgressAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_embed_blocking_rent_progress');
exports.ScreenEmbedBlockingRentProgressAnalyticsEvent = ScreenEmbedBlockingRentProgressAnalyticsEvent;
/**
 * Triggers when user lands on the RXP Embed Flow Blocking Screen 'Balance Out of Range'
 */
var ScreenEmbedBalanceOutOfRangeAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_embed_balance_out_of_range');
exports.ScreenEmbedBalanceOutOfRangeAnalyticsEvent = ScreenEmbedBalanceOutOfRangeAnalyticsEvent;
/**
 * Triggers when user lands on the RXP Embed Flow Blocking Screen 'Something Went Wrong'
 */
var ScreenEmbedBlockingIneligibleAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_embed_blocking_ineligible');
exports.ScreenEmbedBlockingIneligibleAnalyticsEvent = ScreenEmbedBlockingIneligibleAnalyticsEvent;
/**
 * Triggers when user lands on the RXP Embed 'Pay Now Review' Screen
 */
var ScreenEmbedPayNowReviewAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_embed_pay_now_review');
exports.ScreenEmbedPayNowReviewAnalyticsEvent = ScreenEmbedPayNowReviewAnalyticsEvent;
/**
 * Triggers when user lands on the RXP Embed 'Congrats' Screen
 */
var ScreenEmbedCongratsAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_embed_congrats');
exports.ScreenEmbedCongratsAnalyticsEvent = ScreenEmbedCongratsAnalyticsEvent;
/**
 * Triggers when user clicks the 'Pay Now' button on the RXP Embed 'Pay Now Review' Screen
 */
var EmbedReviewPaymentsClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('embed_review_payments_clicked');
exports.EmbedReviewPaymentsClickedAnalyticsEvent = EmbedReviewPaymentsClickedAnalyticsEvent;
/**
 * Triggers when user clicks the 'Review and make payment' button on the RXP Embed 'Congrats' Screen
 */
var EmbedCongratsAutopayOffButtonClickAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('embed_congrats_autopay_off_button_click');
exports.EmbedCongratsAutopayOffButtonClickAnalyticsEvent = EmbedCongratsAutopayOffButtonClickAnalyticsEvent;
/**
 * Triggers when user is about to be redirected to the RXP Embed Blocking Screen 'Something Went Wrong'
 */
var EmbedBillStatusBlockingErrorAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('embed_bill_status_blocking_error');
exports.EmbedBillStatusBlockingErrorAnalyticsEvent = EmbedBillStatusBlockingErrorAnalyticsEvent;
/**
 * Triggers when user is about to be redirected to an appropriate RXP Embed Screen when we have a Bill Status and the user is not in episodic fulfilment state
 */
var EmbedBillStatusBlockingAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('embed_bill_status_blocking');
exports.EmbedBillStatusBlockingAnalyticsEvent = EmbedBillStatusBlockingAnalyticsEvent;
/**
 * Triggers when user is about to be redirected to an appropriate RXP Embed Blocking Screen when we have a Bill Status with a Service Issue Code
 */
var EmbedBillStatusServiceIssueBlockingAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('embed_bill_status_service_issue_blocking');
exports.EmbedBillStatusServiceIssueBlockingAnalyticsEvent = EmbedBillStatusServiceIssueBlockingAnalyticsEvent;
/**
 * Triggers when user is about to be redirected to the RXP Embed Blocking Screen 'Something Went Wrong' based on their Eligibility Check
 */
var EmbedCheckEligibilityErrorAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('embed_check_eligibility_error');
exports.EmbedCheckEligibilityErrorAnalyticsEvent = EmbedCheckEligibilityErrorAnalyticsEvent;
/**
 * Triggers when user is about to be redirected to an appropriate RXP Embed Blocking Screen when the Eligibility Check failed with a failure code
 */
var EmbedEligibilityFailureCodeAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('embed_eligibility_failure_code');
exports.EmbedEligibilityFailureCodeAnalyticsEvent = EmbedEligibilityFailureCodeAnalyticsEvent;
